module.exports = __webpack_public_path__ + "static/media/candidat_heureux.0174fc2d.jpg";